var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgFolderinline = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_1098_2337)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M9.40387 11.1381H24.5064V10.1941C24.5064 9.41493 23.8683 8.77798 23.0904 8.77798H16.857V7.95349C16.857 6.78032 15.9028 5.82996 14.7335 5.82996H11.1082C10.5418 5.82996 10.0094 6.05147 9.60654 6.45429C9.20371 6.85712 8.98343 7.38575 8.98343 7.95349V8.77921H2.75008C1.97093 8.77798 1.33398 9.41487 1.33398 10.1941V22.8409L6.09463 13.1963C6.6724 12.0218 8.09731 11.1381 9.40387 11.1381ZM10.3996 7.95349C10.3996 7.76594 10.4764 7.58842 10.6085 7.45502C10.7407 7.31905 10.9195 7.24483 11.107 7.24483H14.7323C15.1238 7.24483 15.4397 7.56204 15.4397 7.95349V8.77921H10.3996V7.95349H10.3996Z",
  fill: "#0787BE"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M29.7448 12.5518H9.40319C8.62527 12.5518 7.70513 13.1232 7.36399 13.8206L1.89346 24.9027C1.54858 25.5988 1.90478 26.1702 2.6827 26.1702H23.0243C23.8022 26.1702 24.7236 25.6 25.066 24.9027L30.5353 13.8206C30.8789 13.1232 30.5252 12.5518 29.7448 12.5518Z",
  fill: "#0787BE"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_1098_2337"
}, /*#__PURE__*/React.createElement("rect", {
  width: 29.3333,
  height: 29.3333,
  fill: "white",
  transform: "translate(1.33398 1.33337)"
})))));

export default SvgFolderinline;